var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v("Tweet")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "p-2 rounded", attrs: { id: "veracityDisplay" } },
      [
        _c(
          "Tweet",
          {
            key: _vm.tweet.id_str,
            attrs: { id: _vm.tweet.id_str, options: { conversation: "none" } }
          },
          [_c("custom-tweet-display", { attrs: { tweet: _vm.tweet } })],
          1
        ),
        _vm._v(" "),
        _vm.threadReply
          ? _c("div", [
              _c("strong", [_vm._v("Thread")]),
              _vm._v(" -\n            "),
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.showThread = !_vm.showThread
                    }
                  }
                },
                [
                  _c(
                    "strong",
                    [
                      !_vm.showThread
                        ? [_vm._v("show this tweet's thread")]
                        : [_vm._v("hide this tweet's thread")]
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "subtweet-container",
                    { collapse: !_vm.showThread },
                    { "collapse.show": _vm.showThread }
                  ]
                },
                _vm._l(_vm.threadReply, function(subReply) {
                  return _c(
                    "Tweet",
                    {
                      key: subReply.id_str,
                      attrs: {
                        id: subReply.id_str,
                        options: { conversation: "none" }
                      }
                    },
                    [
                      _c("custom-tweet-display", { attrs: { tweet: subReply } })
                    ],
                    1
                  )
                }),
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tweet-veracity-help-modal"),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          !_vm.showProvideFeedback
            ? _c(
                "div",
                {
                  key: "veracityDisplay",
                  staticClass: "p-2 veracity-display rounded position-relative",
                  staticStyle: { background: "rgba(255, 255, 255, 200)" }
                },
                [
                  _c("h4", [_vm._v("Veracity of tweet")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "help-btn",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#rumourVeracityHelpModal"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/images/help.svg",
                          alt: "Explanation of rumour classification",
                          title: "Explanation of rumour classification"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.user.isAuthenticated
                    ? [
                        !_vm.showProvideFeedback
                          ? _c("input", {
                              staticClass: "form-control btn btn-primary",
                              attrs: {
                                id: "veracityFeedbackOptin",
                                type: "button",
                                value: "Provide feedback"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleShowFeedback()
                                }
                              }
                            })
                          : _vm._e()
                      ]
                    : _c("p", [
                        _c("a", { attrs: { href: "/login" } }, [
                          _vm._v("Login")
                        ]),
                        _vm._v(" or "),
                        _c("a", { attrs: { href: "/register" } }, [
                          _vm._v("Register")
                        ]),
                        _vm._v(" to provide feedback.")
                      ]),
                  _vm._v(" "),
                  _c("p")
                ],
                2
              )
            : _c(
                "div",
                {
                  key: "veracityFeedback",
                  staticClass: "p-2 rounded position-relative",
                  staticStyle: { background: "rgba(255, 255, 255, 200)" }
                },
                [
                  _c("h4", [
                    _c("img", {
                      staticStyle: { height: "2em" },
                      attrs: {
                        src: "/static/images/feedback.svg",
                        alt: "Rumour veracity feedback"
                      }
                    }),
                    _vm._v(
                      "\n                    Your\n                    feedback"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "help-btn",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#rumourVeracityHelpModal"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/images/help.svg",
                          alt: "Explanation of rumour classification",
                          title: "Explanation of rumour classification"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                    You can provide your own feedback to the veracity classification here. Drag the slider to\n                    specify the veracity and please provide a reason for your classification.\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [
                      _vm._v("Please drag slider to provide a veracity rating:")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("veracity-slider", {
                    attrs: {
                      veracity: _vm.veracityFeedback,
                      "is-enabled": true
                    },
                    on: { input: _vm.veracityFeedbackChanged }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [
                      _vm._v("Please provide evidence for the veracity rating:")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.veracityEvidenceFeedback,
                        expression: "veracityEvidenceFeedback"
                      }
                    ],
                    staticClass: "form-control mb-4",
                    attrs: {
                      id: "veracityFeedbackEvidenceText",
                      name: "veracityFeedbackText"
                    },
                    domProps: { value: _vm.veracityEvidenceFeedback },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.veracityEvidenceFeedback = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control btn btn-primary mb-2",
                    attrs: {
                      id: "veracityFeedbackSubmit",
                      type: "button",
                      value: "Submit feedback"
                    },
                    on: {
                      click: function($event) {
                        return _vm.submitFeedback()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control btn btn-danger mb-2",
                    attrs: {
                      id: "veracityFeedbackCancel",
                      type: "button",
                      value: "Cancel"
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleShowFeedback()
                      }
                    }
                  })
                ],
                1
              )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "p-2 rounded",
            attrs: { id: "machineVeracityDisplay" }
          },
          [
            _vm.tweet.lang == "en" && _vm.siteConfig.showMachineVeracity
              ? [
                  _c("transition", { attrs: { name: "fade" } }, [
                    !_vm.showVeracity
                      ? _c(
                          "button",
                          {
                            staticClass: "form-control btn btn-secondary mb-2",
                            attrs: { id: "showMachineVeracityBtn" },
                            on: {
                              click: function($event) {
                                return _vm.toggleVeracity()
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "img-fluid",
                              staticStyle: {
                                height: "2em",
                                filter: "invert(100%)"
                              },
                              attrs: {
                                src: "/static/images/robot.svg",
                                alt: "Show auto-veracity prediction",
                                title: "Show auto-veracity prediction"
                              }
                            }),
                            _vm._v(
                              "\n                        Show machine-generated veracity\n                    "
                            )
                          ]
                        )
                      : _c("div", { attrs: { id: "machineVeracity" } }, [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("div", { staticClass: "col-2" }, [
                              _c("img", {
                                staticClass: "img-fluid",
                                staticStyle: { height: "3em" },
                                attrs: {
                                  src: "/static/images/robot.svg",
                                  alt: "Our algorithm says...",
                                  title: "Our algorithm says..."
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-10" },
                              [
                                _c("veracity-slider", {
                                  attrs: { veracity: _vm.veracity }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                  ])
                ]
              : _vm.tweet.lang == "und"
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary form-control mb-2",
                    attrs: {
                      type: "button",
                      title:
                        "Machine-generated veracity not available, text not recognised",
                      disabled: ""
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      staticStyle: { height: "2em", filter: "invert(100%)" },
                      attrs: {
                        src: "/static/images/robot.svg",
                        alt: "Show auto-veracity prediction",
                        title: "Show auto-veracity prediction"
                      }
                    }),
                    _vm._v(
                      "\n                Text not recognised\n            "
                    )
                  ]
                )
              : !_vm.showMachineVeracity
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary form-control mb-2",
                    attrs: {
                      type: "button",
                      title: "Machine-generated veracity disabled",
                      disabled: ""
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      staticStyle: { height: "2em", filter: "invert(100%)" },
                      attrs: {
                        src: "/static/images/robot.svg",
                        alt: "Show auto-veracity prediction",
                        title: "Show auto-veracity prediction"
                      }
                    }),
                    _vm._v(
                      "\n                Machine-generated veracity disabled\n            "
                    )
                  ]
                )
              : _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary form-control mb-2",
                    attrs: {
                      type: "button",
                      title:
                        "Machine-generated veracity not available for this language",
                      disabled: ""
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      staticStyle: { height: "2em", filter: "invert(100%)" },
                      attrs: {
                        src: "/static/images/robot.svg",
                        alt: "Show auto-veracity prediction",
                        title: "Show auto-veracity prediction"
                      }
                    }),
                    _vm._v(
                      "\n                Not available for this language\n            "
                    )
                  ]
                )
          ],
          2
        ),
        _vm._v(" "),
        _vm.siteConfig.showOtherUserVotes
          ? _c("tweet-veracity-responses")
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }